
export const projectsData = [
    {
        id: 1,
        projectName: 'Prime video clone',
        projectDesc: 'Prime Video, is Amazons subscription video on-demand over-the-top streaming and rental service.',
        tags: ["React", "Node.js", "MongoDb", "Express", "CSS"],
        logos: ["fab fa-react", "fab fa-etsy", "fab fa-node", "fas fa-database", "fab fa-css3"],
        code: 'https://github.com/biswajitchikal847/Prime-Video-Clone.git',
        demo: 'https://prime-video-amazon-clone.netlify.app/',
        image: "https://determined-meninsky-76dd0a.netlify.app/images/Screenshot%20(33).png"
    },
    // {
    //     id: 2,
    //     projectName: 'Myglamm',
    //     projectDesc: 'My glamm is an online beauty product selling website, where you can find all type of beauty products. It is a collaborative project.',
    //     tags: ["EJS", "Node.js", "mongoDB", "Express"],
    //     logos: ["fab fa-vuejs", "fas fa-database", "fab fa-js", "fab fa-node", "fab fa-etsy"],
    //     code: 'https://github.com/Sourav12061999/my-glamm-clone',
    //     demo: 'https://my-glamm.herokuapp.com/',
    //     image: "https://user-images.githubusercontent.com/72076630/141668396-44a19b12-0a97-4859-bf97-1610b705de94.png"
    // },
    // {
    //     id: 2, https://my-glamm.herokuapp.com/
    //     projectName: 'Udemy',
    //     projectDesc: 'Udemy is an E-learning web application for online learning and teaching.',
    //     tags: ["Html", "Tailwind", "javascript", "Mock Server"],
    //     logos: ["fab fa-html5", "fab fa-css3", "fab fa-js", "fab fa-etsy"],
    //     code: 'https://github.com/Sachi4496/udemy-clone.git',
    //     demo: 'https://aqueous-fortress-78543.herokuapp.com/',
    //     image: "https://user-images.githubusercontent.com/91539305/147107410-e2cf1961-f777-4e33-8a49-586a9a612cb5.gif"
    // },
    {
        id: 2,
        projectName: 'Nordstrom',
        projectDesc: 'Nordstrom is an USA based lifestyle online store which selling products at customers doorstep. This is an individual project which i have executed in 5 days.',
        tags: ["Html", "css", "javascript"],
        logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
        code: 'https://github.com/biswajitchikal847/Nordstrom_individual_project.git',
        demo: 'https://individual-project-nordstrom.netlify.app/',
        image: "https://determined-meninsky-76dd0a.netlify.app/images/Screenshot%20(238).png"
    },
    {
        id: 3,
        projectName: 'Myglamm',
        projectDesc: 'My glamm is an online beauty product selling website, where you can find all type of beauty products. It is a collaborative project.',
        tags: ["EJS", "Node.js", "mongoDB", "Express"],
        logos: ["fab fa-vuejs", "fas fa-database", "fab fa-js", "fab fa-node", "fab fa-etsy"],
        code: 'https://github.com/Sourav12061999/my-glamm-clone',
        demo: 'https://my-glamm.herokuapp.com/',
        image: "https://user-images.githubusercontent.com/72076630/141668396-44a19b12-0a97-4859-bf97-1610b705de94.png"
    },
    {
        id: 4,
        projectName: 'khols',
        projectDesc: 'This is our unit-2 construct week project.We implement Different types of Functionalities using Advance javascript, css, html and dom',
        tags: ["Html", "css", "javascript"],
        logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
        code: 'https://github.com/Sachi4496/Food-App/tree/main/Food%20App',
        demo: 'https://clonekohlproject.netlify.app/',
        image: "https://camo.githubusercontent.com/d896835a3816e21c715c56d474d1b2b0e6e4cbd74d369b4a1084fa820c5af9ed/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f313032352f312a70753767792d6f514d6566436765375a72344b4542412e706e67"
    },
    // {
    //     id: 4,
    //     projectName: 'Twitter',
    //     projectDesc: 'This clone allows users to tweet,retweet, like, and comment on tweets made by other user ',
    //     tags: ["React", "Node.js", "MongoDb"],
    //     logos: ["fab fa-react","fab fa-etsy","fab fa-node","fas fa-database"],
    //     code: 'https://github.com/Malek1117/twitter_clone_master',
    //     demo: 'https://twitter-client-mu.vercel.app/',
    //     image: "https://user-images.githubusercontent.com/72969348/144738693-71595176-877e-44e1-aff4-413bbec578b9.png"
    // },
    // {
    //     id: 5,
    //     projectName: 'Project Pluralsight',
    //     projectDesc: 'Pluralsight, Inc. is an American privately held online education company that offers a variety of video training courses for software developers, IT administrators, and creative professionals through its website. ',
    //     tags: ["EJS", "Node.js", "mongoDB"],
    //     logos: ["fab fa-vuejs", "fas fa-database", "fab fa-js", "fab fa-node"],
    //     code: 'https://github.com/biswajitdas-007/Pluralsight',
    //     demo: 'https://pluralsightclone-1.herokuapp.com/',
    //     image: "https://user-images.githubusercontent.com/72969348/139317539-6ff80bd4-68f5-47b3-8d9d-90154f451e0d.png"
    // },
    // {
    //     id: 6,
    //     projectName: 'Project MightyCause',
    //     projectDesc: 'It is a online fundraising website for empowering nonprofits donations. We tried to clone the Mightycause website from the scratch. A user can create his/her porfile and create any number of events they want from their dashboard.',
    //     tags: ["React.js", "material.ui"],
    //      logos: ["fab fa-react", "fas fa-database", "fab fa-js"],
    //     code: 'https://github.com/cybervirus997/Mightycause',
    //     demo: 'https://mighty-cause-ravishukla86044.vercel.app/',
    //     image: "https://user-images.githubusercontent.com/77038954/129859566-716f10fe-7b02-465f-962e-981da3632e85.png"
    // },
]



//schema for entwreing data
/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/